import React from 'react';
import { motion } from 'framer-motion';
import '../styles/Hero.css';

const Hero = ({ onPaymentClick }) => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: 'easeOut' },
    },
  };

  return (
    <section className="hero">
      <div className="hero-background">
        <div className="gradient-orb orb-1"></div>
        <div className="gradient-orb orb-2"></div>
      </div>

      <motion.div
        className="hero-content"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <motion.h1 variants={itemVariants} className="hero-title">
          Opera como un PRO en 
          <span className="gradient-text"> 7 días</span>
        </motion.h1>

        <motion.div variants={itemVariants} className="video-container">
          <video
            height="600"
            controls
            autoPlay
            muted
            style={{ borderRadius: '12px', maxWidth: '100%', height: 'auto' }}
          >
            <source src="/IMG_9130.mp4" type="video/mp4" />
            Tu navegador no soporta el elemento de video.
          </video>
        </motion.div>

        <motion.div variants={itemVariants} className="video-description-section">
          <div className="description-header">
            <p className="description-text">Sprint intensivo en enero con operativa en vivo.<br />Verás ejecutar a un gestor de fondos en tiempo real.</p>
          </div>

          <ul className="video-highlights">
            <li>Estrategias mecánicas inteligentes (EMI)</li>
            <li>Liquidez + gestión profesional</li>
            <li>Qué hacer y qué NO hacer en el mercado</li>
          </ul>

          {/* <button className="cta-button video-cta" onClick={onPaymentClick}>
            Asegurar mi cupo por $99 USD
          </button> */}
          <p className="video-cta-subtitle">Acceso especial fin de año – Sprint solo en enero</p>
        </motion.div>

        <motion.div variants={itemVariants} className="cta-section">
          <button className="cta-button primary" onClick={onPaymentClick}>
            Asegurar mi cupo por $99 USD

          </button>

          <div className="trust-badges">
            <div className="badge">
              <span className="badge-icon">📅</span>
              <span>Sprint intensivo – solo enero</span>
            </div>
            <div className="badge">
              <span className="badge-icon">🔴</span>
              <span>100% en vivo</span>
            </div>
            <div className="badge">
              <span className="badge-icon">⚙️</span>
              <span>Operativa real (no señales)</span>
            </div>
            <div className="badge">
              <span className="badge-icon">🔐</span>
              <span>Cupos limitados por agenda</span>
            </div>
          </div>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Hero;
